import React from 'react';
import { NextSeo } from 'next-seo';
import { Header } from '@/src/containers/ContactUs/components/Header';
import PopupManager from '@/src/core/components/PopupManager';
import Footer from '@/src/containers/Landings/Footer';
import PrivacyPolicy from '@/src/containers/PrivacyPolicy';

const source = 'privacy-policy';

function PrivacyPolicyPage() {
  return (
    <>
      <NextSeo
        additionalLinkTags={[
          {
            href: 'https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap',
            rel: 'stylesheet',
          },
        ]}
      />
      <Header />
      <PrivacyPolicy />
      <Footer hasScrollToTop />
      <PopupManager />
    </>
  );
}

PrivacyPolicyPage.pageName = source;
PrivacyPolicyPage.withIntercomChatBot = true;

export default PrivacyPolicyPage;
